module.exports = __webpack_public_path__ + "img/nvHai2.3fd46292.png";